import React, { useEffect, useState } from 'react';
import axios from '../axiosConfig';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';

const GoogleLogin = ({ onError }) => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Google Client ID - 在生产环境中应该从环境变量获取
  const GOOGLE_CLIENT_ID = '576179050004-jmm41qq1mr26sj2lf81itlbdv8lsvrk3.apps.googleusercontent.com';

  useEffect(() => {
    // 检查Google SDK是否已加载
    const checkGoogleSDK = () => {
      if (window.google && window.google.accounts) {
        setIsGoogleLoaded(true);
        initializeGoogleSignIn();
      } else {
        // 如果未加载，延迟检查
        setTimeout(checkGoogleSDK, 500);
      }
    };

    checkGoogleSDK();
  }, []);

  const initializeGoogleSignIn = () => {
    try {
      console.log('正在初始化Google登录，Client ID:', GOOGLE_CLIENT_ID);
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
        ux_mode: 'popup', // 使用弹窗模式避免重定向问题
        context: 'signin'
      });
      console.log('Google登录初始化成功');
    } catch (error) {
      console.error('Google登录初始化失败:', error);
      onError && onError('Google登录服务初始化失败: ' + error.message);
    }
  };

  const handleGoogleLogin = async () => {
    if (!isGoogleLoaded) {
      onError && onError('Google登录服务正在加载中，请稍后重试');
      return;
    }

    if (isLoading) {
      return;
    }

    setIsLoading(true);

    try {
      // 显示Google登录弹窗
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // 如果弹窗没有显示，尝试使用renderButton方法
          onError && onError('请允许弹窗并重试，或检查浏览器设置');
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Google登录失败:', error);
      onError && onError('Google登录失败，请重试');
      setIsLoading(false);
    }
  };

  const handleCredentialResponse = async (response) => {
    try {
      // 解析JWT token获取用户信息
      const credential = response.credential;
      const payload = parseJwt(credential);
      
      const googleUserData = {
        googleId: payload.sub,
        email: payload.email,
        name: payload.name,
        picture: payload.picture
      };

      console.log('Google用户数据:', googleUserData);

      // 调用后端Google登录接口
      const loginResponse = await axios.post('/yonghu/googleLogin', null, {
        params: {
          googleId: googleUserData.googleId,
          email: googleUserData.email,
          name: googleUserData.name
        }
      });

      if (loginResponse.data.code === 0) {
        const { userId, token, username } = loginResponse.data;
        const userData = { 
          id: userId, 
          zhanghao: username, 
          role: 'yonghu',
          loginType: 'google'
        };

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userData', JSON.stringify(userData));
        
        login(userData, token);
        
        // 获取完整用户信息
        try {
          const userResponse = await axios.get(`/yonghu/info/${userId}`);
          if (userResponse.data.code === 0) {
            const fullUserData = {
              ...userData,
              ...userResponse.data.data
            };
            
            localStorage.setItem('user', JSON.stringify(fullUserData));
            localStorage.setItem('userData', JSON.stringify(fullUserData));
            login(fullUserData, token);
          }
        } catch (err) {
          console.error("获取用户详情失败:", err);
        }
        
        // 跳转到用户页面
        navigate(`/users/${userId}`);
      } else {
        onError && onError(loginResponse.data.msg || 'Google登录失败');
      }
    } catch (error) {
      console.error('Google登录处理失败:', error);
      onError && onError('Google登录处理失败');
    }
  };

  // 解析JWT token
  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('JWT解析失败:', error);
      return {};
    }
  };

  return (
    <button 
      onClick={handleGoogleLogin}
      disabled={!isGoogleLoaded || isLoading}
      className="google-login-btn"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '12px',
        backgroundColor: isGoogleLoaded ? '#4285f4' : '#cccccc',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: isGoogleLoaded ? 'pointer' : 'not-allowed',
        marginBottom: '15px',
        transition: 'background-color 0.3s',
        opacity: isLoading ? 0.7 : 1
      }}
      onMouseOver={(e) => {
        if (isGoogleLoaded && !isLoading) {
          e.target.style.backgroundColor = '#357ae8';
        }
      }}
      onMouseOut={(e) => {
        if (isGoogleLoaded && !isLoading) {
          e.target.style.backgroundColor = '#4285f4';
        }
      }}
    >
      <FontAwesomeIcon icon={faGoogle} style={{ marginRight: '8px' }} />
      {isLoading ? '登录中...' : 
       isGoogleLoaded ? '使用 Google 账号登录' : 'Google 服务加载中...'}
    </button>
  );
};

export default GoogleLogin; 